module.exports = __webpack_public_path__ + "img/Friends&Family.e704401d.webp";